import { AMORTIZATION_TYPES, LOAN_RATE_TYPES } from "@loanbossinc/component-library";
import { isContainedInList } from "helpers/row-logic-helper";
import { get } from "lodash";

export const shouldShowAmortization = data => Boolean(get(data, "amortizationDetails.amortization"));

export const shouldShowAmortizationStartDate = data => Boolean(get(data, "amortizationDetails.amortizationStartDate")) && isContainedInList(data, "amortizationDetails.amortizationTypeId", [,
  AMORTIZATION_TYPES.AGENCY_FLOATER,
  AMORTIZATION_TYPES.MORTGAGE_STYLE,
  AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT]);

export const shouldShowAmortizationStartDateEdit = data => isContainedInList(data, "amortizationDetails.amortizationTypeId", [,
  AMORTIZATION_TYPES.AGENCY_FLOATER,
  AMORTIZATION_TYPES.MORTGAGE_STYLE,
  AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT]);

export const shouldShowMonthlyPayment = data => Boolean(get(data, "details.currentPayment")) && isContainedInList(data, "amortizationDetails.amortizationTypeId", [
  AMORTIZATION_TYPES.MORTGAGE_STYLE
]);

export const shouldShowMonthlyPrincipalReduction = data => Boolean(get(data, "amortizationDetails.monthlyPrincipalReduction")) && isContainedInList(data, "amortizationDetails.monthlyPrincipalReduction", [
  AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT
]);

export const shouldShowMonthlyPrincipalReductionEdit = data => isContainedInList(data, "amortizationDetails.amortizationTypeId", [
  AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT
]);

export const shouldShowAmortizationTerm = data => Boolean(get(data, "amortizationDetails.amortizationTerm")) && isContainedInList(data, "amortizationDetails.amortizationTypeId", [,
  AMORTIZATION_TYPES.AGENCY_FLOATER,
  AMORTIZATION_TYPES.MORTGAGE_STYLE,
  AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT]);

export const shouldShowAmortizationTermEdit = data => isContainedInList(data, "amortizationDetails.amortizationTypeId", [,
  AMORTIZATION_TYPES.AGENCY_FLOATER,
  AMORTIZATION_TYPES.MORTGAGE_STYLE,
  AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT]);

export const shouldShowAmortizationRate = data => {
  const isCorrectAmortRateType = isContainedInList(data, "amortizationDetails.amortizationTypeId", [
    AMORTIZATION_TYPES.MORTGAGE_STYLE
  ]);

  const isCorrectRateType = isContainedInList(data, "details.rateTypeId", [
    LOAN_RATE_TYPES.FLOATING
  ]);

  return Boolean(get(data, "amortizationDetails.amortizationRate")) && isCorrectAmortRateType && isCorrectRateType;
};

export const shouldShowAmortizationRateEdit = data => {
  const isCorrectAmortRateType = isContainedInList(data, "amortizationDetails.amortizationTypeId", [
    AMORTIZATION_TYPES.MORTGAGE_STYLE
  ]);

  const isCorrectRateType = isContainedInList(data, "details.rateTypeId", [
    LOAN_RATE_TYPES.FLOATING
  ]);

  return isCorrectAmortRateType && isCorrectRateType;
};

export const shouldShowAmortizationTypeId = loan => Boolean(get(loan, "amortizationDetails.amortizationType.name"));

export const shouldShowInterestCalculation = loan => Boolean(get(loan, "amortizationDetails.interestCalculation"));

export const shouldShowCalculationPeriods = loan => Boolean(get(loan, "amortizationDetails.ioPeriod"));

export const shouldShowMisc = loan => Boolean(get(loan, "amortizationDetails.amortMisc"));

export const shouldShowPaymentDay = loan => Boolean(get(loan, "details.paymentDay"));

export const shouldShowBusinessDayAdjustment = loan => Boolean(get(loan, "details.businessDayAdjustment"));
